import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import React from 'react';
import ProfileImage from '../../../../common/ProfileImage';

const SlotParticipantItem = ({ booking, details, isResource }) => {
	const dictionary = useDictionary();

	return (
		<>
		{
			booking.booking_participants.map((bookingParti,index)=>{
				return (
					<div
						className="participant-row-container"
						style={{ minWidth: 680, marginBottom: (window.innerWidth > 767 ? '16px' : '8px') }}
						key={bookingParti.id}
					>
						<div className='d-flex justify-between items-center booking-participants-container' style={{width:'70%'}}>
							<div className='d-flex items-center participant-column name-column'>
								<ProfileImage name={bookingParti?.name} photo={bookingParti?.avatar_url} size={{width: 32, height: 32, fontSize: 13, lineHeight: 16}}/>
								<h4
									className='truncate'
									style={{ fontWeight: 'normal', marginLeft: '8px',maxWidth:'120px' }}
									data-testid="customer-name"
									title={bookingParti?.name ? bookingParti?.name : `${dictionary.participant} ${index+1}`}
								>
									{bookingParti?.name ? bookingParti?.name : `${dictionary.participant} ${index+1}`}
								</h4>
							</div>
							<div className='participant-column'>
							<h4
								style={{ fontWeight: 'normal',opacity:0.6,maxWidth:'120px' }}
								className='truncate'
								data-testid="customer-name"
								title={bookingParti?.participant_group}
							>
								{bookingParti?.participant_group}
							</h4>
							</div>
							<div className='participant-column'>
							<h4
								style={{ fontWeight: 'normal',opacity:0.6  }}
							>
								({`${bookingParti.check_in}/${bookingParti.check_in_allowed_quantity}`})
							</h4>
							</div>
						</div>

						<div className="flex-filler" />
						{index === 0 ? (
							<h4
								style={{ fontWeight: 'bold', marginLeft: '8px' }}
								data-testid="booking-index"
							>
								{booking?.display_id}
							</h4>
						) : null}
						{/*<div className='flex-filler'/>
						<h4 style={{fontSize:'12px', cursor:'pointer'}}>{dictionary.edit}</h4>
						<h4 style={{marginLeft:'20px', fontSize:'12px', cursor:'pointer', color:'var(--brand-red)'}}>{dictionary.remove}</h4>*/}
					</div>
				)
			})
		}
		</>
	);
};

SlotParticipantItem.propTypes = {
	booking: PropTypes.object,
	details: PropTypes.object,
	isResource: PropTypes.bool
};

export default SlotParticipantItem;
